const CLEANUP_KEY = '__mmsDropdownPositionCleanup';

export default function stickDropdownToSelect(dropdownList, component, options = {}) {
	if (!dropdownList) {
		return () => {};
	}

	if (typeof dropdownList[CLEANUP_KEY] === 'function') {
		dropdownList[CLEANUP_KEY]();
	}

	const { width, offsetY = 0, align = 'left' } = options;

	const getTriggerEl = () => component && (component.$el || component.vnode && component.vnode.el);

	const positionDropdown = () => {
		const el = getTriggerEl();
		if (!el || typeof el.getBoundingClientRect !== 'function') {
			return;
		}

		const pos = el.getBoundingClientRect();
		const spaceBelow = window.innerHeight - pos.bottom - 8;
		const spaceAbove = pos.top - 8;
		// Prefer opening down; only flip up when there is clearly more room above.
		const openUp = spaceBelow < 120 && spaceAbove > spaceBelow;
		const available = openUp ? spaceAbove : spaceBelow;
		const maxHeight = Math.min(240, Math.max(120, available));

		dropdownList.style.position = 'fixed';
		dropdownList.style.width = width || `${pos.width}px`;
		dropdownList.style.zIndex = '4000';
		dropdownList.style.maxHeight = `${maxHeight}px`;
		dropdownList.style.overflowY = 'auto';

		if (openUp) {
			dropdownList.style.top = 'auto';
			dropdownList.style.bottom = `${window.innerHeight - pos.top + offsetY}px`;
		} else {
			dropdownList.style.bottom = 'auto';
			dropdownList.style.top = `${pos.bottom + offsetY}px`;
		}

		if (align === 'right') {
			dropdownList.style.left = 'auto';
			dropdownList.style.right = `${window.innerWidth - pos.right}px`;
		} else {
			dropdownList.style.left = `${pos.left}px`;
			dropdownList.style.right = 'auto';
		}
	};

	positionDropdown();

	window.addEventListener('scroll', positionDropdown, true);
	window.addEventListener('resize', positionDropdown);

	const cleanup = () => {
		window.removeEventListener('scroll', positionDropdown, true);
		window.removeEventListener('resize', positionDropdown);
		if (observer) {
			observer.disconnect();
		}
		if (dropdownList[CLEANUP_KEY] === cleanup) {
			delete dropdownList[CLEANUP_KEY];
		}
	};

	const observer = new MutationObserver(() => {
		if (!dropdownList.isConnected) {
			cleanup();
		}
	});
	observer.observe(document.body, { childList: true, subtree: true });

	dropdownList[CLEANUP_KEY] = cleanup;
	return cleanup;
}
